<script setup lang="ts">
    import type { PrimitiveProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import type { ItemVariants } from '.';
    import { Primitive } from 'reka-ui';
    import { cn } from '../utils';
    import { itemVariants } from '.';

    const props = withDefaults(
        defineProps<
            PrimitiveProps & {
                class?: HTMLAttributes['class'];
                variant?: ItemVariants['variant'];
                size?: ItemVariants['size'];
            }
        >(),
        {
            as: 'div',
        },
    );

    defineOptions({ inheritAttrs: false });

    const attrs = useAttrs();
    const primitiveRef = useTemplateRef('primitive');
    defineExpose({ $el: computed(() => primitiveRef.value?.$el) });
</script>

<template>
    <Primitive
        ref="primitive"
        data-slot="item"
        :as="as"
        :as-child="asChild"
        :data-size="size"
        :class="cn(itemVariants({ variant, size }), props.class)"
        :style="`--item-padding: 16px;`"
        v-bind="attrs"
    >
        <slot />
    </Primitive>
</template>
